import { Observable, of, EMPTY, isObservable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import Global from '../../store/global-selectors';
import { JobPipelineService } from '../../services/job-pipeline-service';
import * as Actions from './job-pipeline.actions';

export const startJobPipeline = (action$, { getState }) => {
  return action$.pipe(
    ofType(Actions.START_JOB_PIPELINE),
    mergeMap(({ jobId }) => {
      const state = getState();
      const calculatedJobId = jobId || Global.selectJobPipelineLastAddedJobId(state);
      const job = Global.selectJobPipelineJobByJobId(state, {
        jobId: calculatedJobId,
      });
      if (!job || !calculatedJobId) {
        return EMPTY;
      }
      return of(Actions.runPipelineStepForJob(calculatedJobId));
    }),
  );
};

export const runPipelineStepForJob = (action$, { getState }) => {
  return action$.pipe(
    ofType(Actions.RUN_PIPELINE_STEP_FOR_JOB),
    mergeMap(({ jobId }) => {
      const state = getState();
      const job = Global.selectJobPipelineJobByJobId(state, { jobId });
      if (!job) {
        return EMPTY;
      }
      const { currentPipelineIndex, pipelineId } = job;
      const { pipeline } = JobPipelineService.getPipelineById(pipelineId);
      const currentPipelineStep = pipeline[currentPipelineIndex];
      if (!currentPipelineStep) {
        return of(Actions.exitJobPipeline(jobId));
      }
      return new Observable((observer) => {
        const nextActions = currentPipelineStep(state, jobId);
        observer.next(nextActions);
        observer.complete();
      }).pipe(
        mergeMap((next) => {
          if (isObservable(next)) {
            return next;
          }
          return Array.isArray(next) ? of(...next) : of(next);
        }),
      );
    }),
  );
};

export const handleCurrentPipelineIndexChanged = (action$) => {
  return action$.pipe(
    ofType(Actions.GO_FORWARD_ON_JOB),
    mergeMap(({ jobId }) => {
      return of(Actions.runPipelineStepForJob(jobId));
    }),
  );
};

export const exitPipeline = (action$, { getState }) => {
  return action$.pipe(
    ofType(Actions.EXIT_JOB_PIPELINE),
    mergeMap(({ jobId }) => {
      const state = getState();
      const job = Global.selectJobPipelineJobByJobId(state, { jobId });
      if (!job) {
        return EMPTY;
      }
      const { pipelineId } = job;
      const { onExit } = JobPipelineService.getPipelineById(pipelineId);
      const actions = [];
      if (onExit) {
        const onExitAction = onExit(jobId, state);
        if (onExitAction) {
          actions.push(onExitAction);
        }
      }
      actions.push(Actions.deleteJob(jobId));
      return of(...actions);
    }),
  );
};
